import React from 'react';
import { Box, Container, Grid, Typography } from '@mui/material';

import style from './style';
import LazyImage from '../../Layouts/LazyImage';

const BackedBy = ({ data }) => {
  const classes = style();

  return (
    <Box className={classes.segment}>
      <Container maxWidth="md">
        <Grid container justifyContent={'center'}>
          <Grid item xs={6} sm={6}>
            <Typography
              variant="h6"
              pb={7}
              textAlign={'center'}
              color={'textSecondary'}
            >
              {data?.title}
            </Typography>
          </Grid>
        </Grid>
        <Grid
          container
          alignItems={'center'}
          spacing={8}
          justifyContent={'center'}
        >
          {data?.contents.map((content, key) => {
            return (
              <Grid item xs={8} sm={4} className={classes.card} key={key}>
                <div>
                  <LazyImage
                    quality={85}
                    sizes={sizes}
                    src={content?.img}
                    alt={content?.altImg}
                  />
                </div>
              </Grid>
            );
          })}
        </Grid>
      </Container>
    </Box>
  );
};

const sizes = {
  xxl: [233, 72],
};

export default BackedBy;
